import * as React from 'react';

import {Button} from 'shells/button/button';

import {BulkSyncPopover} from './bulk-sync-popover';

type Props = {
    onSubmit: (arg1: string) => Promise<any>;
    selectedCount: number;
    entityType: 'leads' | 'contacts';
};

export function BulkSyncButton(props: Props) {
    const [isShowingPopover, setIsShowingPopover] = React.useState<boolean>(false);
    const syncButton = React.useRef(null);

    return (
        <>
            <Button
                id='for-intercom-sync-leads-button'
                size='big'
                disabled={props.selectedCount <= 0}
                onClick={() => setIsShowingPopover(true)}
                getButtonRef={syncButton}
            >
                Sync to WebFX
            </Button>
            {isShowingPopover ? (
                <BulkSyncPopover
                    anchor={syncButton.current}
                    onCancel={() => setIsShowingPopover(false)}
                    onSubmit={props.onSubmit}
                    selectedCount={props.selectedCount}
                    entityType={props.entityType}
                />
            ) : undefined}
        </>
    );
}
